import {boot} from "quasar/wrappers"
import mitt from "mitt"
import router from 'src/router'
// "async" is optional;
// more info on params: https://v2.quasar.dev/quasar-cli/boot-files
export default boot(async ({app} /* { app, router, ... } */) => {

  window.vuevm = app

  // something to do
  const emitter = mitt()
  app.config.globalProperties.emitter = emitter
  app.config.globalProperties.eventBus = {
    globalErrorHandling(msg, error, logMsg) {
      emitter.emit("globalErrorHandling", {msg, error, logMsg, router})
    },

    evtDataError(title, msg) {
      emitter.emit("evtDataError", {msg, title, logMsg: "", router})
    },

    changeDeviceOrientationLandscape() {
      emitter.emit("evtChangeDeviceOrientation", "landscape")
    },

    changeDeviceOrientationPortrait() {
      emitter.emit("evtChangeDeviceOrientation", "portrait")
    },

    refreshFavList() {
      emitter.emit('refreshFavList')
    },

    //refreshValueListComp(nativename, valueList, errorFetchingData, errorMsg){
    //  emitter.emit("onRefreshValueList", { nativename, valueList, errorFetchingData, errorMsg })
    //},

    refreshComp(nativename, value, errorFetchingData, errorMsg, sideQueryExecDone, parentClassID) {
      emitter.emit("onRefreshComp", {parentClassID, nativename, value, errorFetchingData, errorMsg, sideQueryExecDone})
    },

    refreshCompDefault(parentClassID, nativename, value, defaultValue, errorFetchingData, errorMsg, subtypeCount, sourceChangedNativename, isEventFromParameter) {
      emitter.emit("onRefreshComp", {parentClassID, nativename, value, defaultValue, errorFetchingData, errorMsg, subtypeCount, sourceChangedNativename, isEventFromParameter})
    },

    emit(name, value) {
      emitter.emit(name, value)
    },

    clearValueListComp(nativename, resetValue, sourceChangedNativename, subtypeCount, guid) {
      emitter.emit("onClearValueList", {nativename, resetValue, sourceChangedNativename, subtypeCount, guid})
    },

    clearValuelistSelection(nativename, subtypeCount) {
      emitter.emit("onClearValuelistSelection", {nativename, subtypeCount})
    },

    showCompSpinner(id, spinnerOnOff) {
      //if(id=='{53162A32-ED5B-11EA-8B3F-309C23AC5997}')
      //console.log("emit onShowSpinner event with id ", id, spinnerOnOff)
      emitter.emit("onShowSpinner", {id, spinnerOnOff})
    },

    gmapPOI(lat, lng, title) {
      emitter.emit("gmapPOI", {lat, lng, title})
    },

    //chart(title, type){
    //  emitter.emit("chart", { title, type })
    //},

    refreshDetailView() {
      emitter.emit("refreshDetailView")
    },

    uploadFileFormFields(classID, fnResolve, subtypeCount, possibleSubclassCounter) {
      emitter.emit("onUploadFileFormField", {classID, fnResolve, subtypeCount, possibleSubclassCounter})
    },

    doOCR() {
      emitter.emit("onOCR")
    },

    doPhoto() {
      emitter.emit("onTakePhoto")
    },

    setFocus(focusFieldNativename, initialScroll) {
      emitter.emit("onSetFocus", {focusFieldNativename, initialScroll})
    },

    exportQuery(type) {
      emitter.emit("onExportQuery", {type})
    },

    executeAndExportQuery(extension) {
      emitter.emit("onExecuteAndExportQuery", extension)
    },

    resizeContentWindow() {
      emitter.emit("resizeContentWindow", {})
    },

    on(eventName, callback) {
      emitter.on(eventName, callback)
    },

    off(eventName, callback) {
      emitter.off(eventName, callback)
    },

    hideOrDisableFieldsInSubclass(masterId, value, changedField) {
      emitter.emit("onHideOrDisableFieldsInSubclass", {masterId, value, changedField})
    },

    hideOrDisableForAllFields() {
      emitter.emit("onHideOrDisableForAllFields")
    },

    incrementSubtypeCount() {
      emitter.emit("onIncrementSubtypeCount")
    },

    refreshParentForm(formProperty) {
      emitter.emit("onRefreshParentForm", {formProperty})
    },

    continueButtonAdd(nativename) {
      emitter.emit("onContinueButtonAdd", {nativename})
    },

    decrementSubtypeCount() {
      emitter.emit("onDecrementSubtypeCount")
    },

    loadSideQuery(sideQueryID, queryID, queryParameter) {
      emitter.emit("loadSideQuery", {sideQueryID, queryID, queryParameter})
    },

    loadSideQueryDone() {
      emitter.emit("loadSideQueryDone")
    },

    printPreview(url, filename) {
      emitter.emit("onPrintPreview", {url, filename})
    },

    openPopup(formProperty, renderPopupButtons) {
      emitter.emit("onOpenPopup", {formProperty, renderPopupButtons})
    },

    printPreviewWithDocID(docID) {
      emitter.emit("onPrintPreviewWithDocID", {docID})
    },

    queryRowSel(senderQueryID, col, value) {
      emitter.emit("onQueryRowSel", {senderQueryID, col, value})
    },

    subformularInvalidLazy(invalidLazyinSub, objectClassID) {
      emitter.emit("onSubformularInvalidLazy", {invalidLazyinSub, objectClassID})
    },

    queryBackBtn() {
      emitter.emit("queryBackBtn")
    },

    formularEdited() {
      emitter.emit("formularEdited")
    },

    formularApply(commitParentObjClassID, formProperty) {
      emitter.emit("onFormularApply", {commitParentObjClassID, formProperty})
    },

    resetFormularEditState() {
      emitter.emit("resetFormularEditState")
    },

    autocompleteApplyButton(nativename, value, subtypeCount) {
      emitter.emit("onAutocompleteApplyButton", {nativename, value, subtypeCount})
    },

    changeFormularField(formID, formProperty, value, deleteDependentFields) {
      let event = {
        classID: formProperty.classID,
        deleteDependentFields: deleteDependentFields,
        nativename: formProperty.nativename,
        parentClassID: formProperty.parentFormPointer?.classID,
        subtypeCount: formProperty.subtypeCount,
        value: value
      }
      formProperty.value = value
      emitter.emit("onChangeFormularField", {formID, event, formProperty})
    },

    setPropertyValue(formProperty, value) {
      emitter.emit("onSetPropertyValue", {formProperty, value})
    },

    clickFrmTitleButton(btnNativenameToClick) {
      emitter.emit("onClickFrmTitleButton", btnNativenameToClick)
    },

    frmNextButtonLock(btnNativenameToClick) {
      emitter.emit("onFrmNextButtonLock", btnNativenameToClick)
    },

    refreshPopupCallerFields() {
      emitter.emit("onRefreshPopupCallerFields", {})
    },

    toggleCollapseAllPanels(subFormularID, collapseAllPanels) {
      emitter.emit("onToggleCollapseAllPanels", { subFormularID, collapseAllPanels})
    }


  }
})
